import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";


import UserReducer from "./featuer/user/userSlice";
import DiviceUser from "./featuer/divice/diviceUser";


const persistConfig = {
  key: "root",
  storage,
  blacklist: ["_persist"],
};

const reducer = combineReducers({
  user: UserReducer,
  divice: DiviceUser
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export default store;
